import React from 'react';
import {
  Link as RACLink,
  type LinkProps as RACLinkProps,
  composeRenderProps,
} from 'react-aria-components';
import { twMerge } from 'tailwind-merge';
import { type AsChildProps, Slot } from './slot';
import { focusOutlineStyle } from './utils';

export type LinkProps = AsChildProps<RACLinkProps>;

const linkStyle = [
  'relative inline-flex cursor-pointer items-center gap-1 rounded-sm outline-hidden hover:underline',
  'text-base/6 sm:text-sm/6',
  'disabled:no-underline disabled:opacity-50 disabled:cursor-default',
  '[&.border]:hover:no-underline',
];

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(function Link(props, ref) {
  if (props.asChild) {
    return <Slot className={twMerge(linkStyle)}>{props.children}</Slot>;
  }

  const { asChild, ...rest } = props;

  return (
    <RACLink
      {...rest}
      ref={ref}
      className={composeRenderProps(props.className, (className, renderProps) => {
        return twMerge([linkStyle, renderProps.isFocusVisible && focusOutlineStyle, className]);
      })}
    />
  );
});
